import { render, staticRenderFns } from "./richView.vue?vue&type=template&id=61ee82f0&scoped=true&"
import script from "./richView.vue?vue&type=script&lang=js&"
export * from "./richView.vue?vue&type=script&lang=js&"
import style0 from "./richView.vue?vue&type=style&index=0&lang=less&"
import style1 from "./richView.vue?vue&type=style&index=1&id=61ee82f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee82f0",
  null
  
)

export default component.exports